// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 9 hooks for backend/placement.

import { useBackend } from '../useBackend'

/** POST /api/placement/answerMoveNotice */
export function useAnswerMoveNotice<T = any>() {
  return useBackend<T>('placement/answerMoveNotice')
}

/** POST /api/placement/answerReliefOffer */
export function useAnswerReliefOffer<T = any>() {
  return useBackend<T>('placement/answerReliefOffer')
}

/** POST /api/placement/getPlacement */
export function useGetPlacement<T = any>() {
  return useBackend<T>('placement/getPlacement')
}

/** POST /api/placement/openDriverMovingLink */
export function useOpenDriverMovingLink<T = any>() {
  return useBackend<T>('placement/openDriverMovingLink')
}

/** POST /api/placement/recordMoveNotice */
export function useRecordMoveNotice<T = any>() {
  return useBackend<T>('placement/recordMoveNotice')
}

/** POST /api/placement/recordPlacementStep */
export function useRecordPlacementStep<T = any>() {
  return useBackend<T>('placement/recordPlacementStep')
}

/** POST /api/placement/recordReliefOffer */
export function useRecordReliefOffer<T = any>() {
  return useBackend<T>('placement/recordReliefOffer')
}

/** POST /api/placement/releaseHiringHold */
export function useReleaseHiringHold<T = any>() {
  return useBackend<T>('placement/releaseHiringHold')
}

/** POST /api/placement/setBenchCause */
export function useSetBenchCause<T = any>() {
  return useBackend<T>('placement/setBenchCause')
}
